import React, { useEffect, useState } from "react";
import {
  CButton,
  CContainer,
  CForm,
  CFormInput,
  CFormSelect,
  CRow,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormLabel,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CFormCheck,
  CModalFooter,
} from "@coreui/react";
import { useDispatch } from "react-redux";
import { EmployeePorvider } from "./provider";
import { setSchemaName } from "src/redux/actions/staffAction";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CameraIndoorOutlined } from "@mui/icons-material";
import { Loader, MODULE_GROUPS } from "src/services/const";

const AddStaffForm = (event) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [schemaname, setSchemaname] = useState("");
  const [permissions, setPermissions] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [showBtn, setShowBtn] = useState(false);
  const [visible, setVisible] = useState(false);
  const { Dealers } = useSelector((state) => state?.customerReducer);
  const currentDate = new Date();
  const maxDateJoining = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );

  const maxJoining = `${maxDateJoining.getFullYear()}-${(
    maxDateJoining.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${maxDateJoining.getDate().toString().padStart(2, "0")}`;
  const maxDoB = new Date(
    currentDate.getFullYear() - 18,
    currentDate.getMonth(),
    currentDate.getDate()
  );
  const maxDateOfBirth = `${maxDoB.getFullYear()}-${(maxDoB.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${maxDoB.getDate().toString().padStart(2, "0")}`;

  useEffect(() => {
    const schemaname = sessionStorage.getItem("schemaName");
    dispatch(setSchemaName(schemaname));
    setSchemaname(schemaname);
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("isEdit") === "1") {
      setIsEdit(true);
    }
  }, []);

  const {
    employeeData,
    onChangeValue,
    handleSubmit,
    handleSelectChange,
    error,
    passPortPhotoRef,
    loader,
    aadharImageRef,
    setPermitted_routes,
  } = EmployeePorvider();

  const {
    userName,
    password,

    firstName,
    dob,

    email,
    phoneNumber,
    address,
    emergencyContactInformation,
    emergencyContactNumber,

    dateOfHire,
    shopName,
    aadharImageUrl,

    passportSizePhoto,

    aadharNumber,

    employeeRole,
    empStatus,
  } = employeeData;

  const branchId = JSON.parse(sessionStorage.getItem("branc"));
  const role = sessionStorage.getItem("role");
  const formatLabel = (slug) =>
    slug.replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  const MODULE_MAP = Object.entries(MODULE_GROUPS)
    .flatMap(([groupName, modules]) =>
      modules.map((module) => ({
        key: module,
        name: formatLabel(module),
        path: `/${module.replace(/_/g, "-")}`,
      }))
    )
    .reduce((acc, { key, name, path }) => {
      acc[key] = { name, path };
      return acc;
    }, {});

  const handleToggleModule = (module) => {
    setPermissions((prev) =>
      prev.includes(module)
        ? prev.filter((m) => m !== module)
        : [...prev, module]
    );
  };

  const savePermissions = async () => {
    const permitted_routes = permissions
      .filter((module) => MODULE_MAP[module])
      .map((module) => MODULE_MAP[module]);
    setShowBtn(true);
    setPermitted_routes(JSON.stringify(permitted_routes));
    setVisible(false);
  };

  return (
    <>
      <CModal visible={visible} onClose={() => setVisible(false)} size="xl">
        <CModalHeader>
          <CModalTitle>Permissions for</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <strong>Select Allowed Modules:</strong>
          <CAccordion alwaysOpen>
            {Object.entries(MODULE_GROUPS).map(
              ([groupName, modules], index) => (
                <CAccordionItem key={groupName} itemKey={index}>
                  <CAccordionHeader>{groupName}</CAccordionHeader>
                  <CAccordionBody>
                    <div className="d-flex flex-wrap">
                      {modules.map((module) => (
                        <CFormCheck
                          key={module}
                          type="checkbox"
                          label={formatLabel(module)}
                          className="me-4 mb-2"
                          checked={permissions.includes(module)}
                          onChange={() => handleToggleModule(module)}
                        />
                      ))}
                    </div>
                  </CAccordionBody>
                </CAccordionItem>
              )
            )}
          </CAccordion>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Cancel
          </CButton>
          <CButton color="primary" onClick={savePermissions}>
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>
      <CRow className="content mb-4">
        <CCol xs={12}>
          <CCard className="custom-card">
            <CCardHeader>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>{isEdit ? "Edit Staff" : "Add Staff"}</div>
                <button
                  type="button"
                  className="custom-close-btn"
                  aria-label="Close"
                  onClick={() => navigate("/staff")}
                >
                  {" "}
                  X
                </button>
              </div>
            </CCardHeader>
            <div className="theform_text">
              <CCardBody className="custom-card-body">
                <CContainer>
                  <CForm
                    onSubmit={(event) => handleSubmit(event, isEdit)}
                    autoComplete="off"
                  >
                    <div className="staffform_header">
                      <span>Basic Details :</span>
                      <span className="mb-4">
                        {isEdit ? (
                          <>
                            <CFormLabel>Branch Name</CFormLabel>
                            <CFormInput
                              type="text"
                              value={employeeData?.branch?.branchName}
                              disabled
                            />
                          </>
                        ) : (
                          <CRow>
                            <CFormLabel className="custom-form-label">
                              Select Branch
                              <span className="red-star">{` `}*</span>
                            </CFormLabel>
                            <CFormSelect
                              id="userName"
                              name="userName"
                              onChange={handleSelectChange}
                              required
                              className="custom-form-input"
                            >
                              <option value="">Select Branch</option>
                              {Dealers?.data?.map((branch) => (
                                <option key={branch.id} value={branch.id}>
                                  {branch.branchName}
                                </option>
                              ))}
                            </CFormSelect>
                          </CRow>
                        )}
                      </span>{" "}
                    </div>
                    {!isEdit && (
                      <CRow className="pt-20">
                        <CCol xs={6}>
                          <CFormLabel
                            htmlFor="userName"
                            className="custom-form-label"
                          >
                            User Name
                            <span className="red-star">{` `}*</span>
                          </CFormLabel>
                          <CFormInput
                            type="text"
                            id="userName"
                            placeholder="User Name"
                            name="userName"
                            value={userName}
                            onChange={onChangeValue}
                            required
                            className="custom-form-input"
                          />
                        </CCol>
                        <CCol xs={6}>
                          <CFormLabel
                            htmlFor="password"
                            className="custom-form-label"
                          >
                            Password
                            <span className="red-star">{` `}*</span>
                          </CFormLabel>
                          <CFormInput
                            type="text"
                            id="password"
                            placeholder="Password"
                            name="password"
                            value={password}
                            onChange={onChangeValue}
                            className="custom-form-input"
                          />
                        </CCol>
                      </CRow>
                    )}
                    <CRow className="pt-20">
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="firstName"
                          className="custom-form-label"
                        >
                          Full Name
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormInput
                          type="text"
                          id="firstName"
                          placeholder="Full Name"
                          name="firstName"
                          value={firstName}
                          onChange={onChangeValue}
                          required
                          className="custom-form-input"
                        />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="planType"
                          className="custom-form-label"
                        >
                          Date of Birth
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormInput
                          type="date"
                          id="dob"
                          name="dob"
                          value={dob}
                          onChange={onChangeValue}
                          max={maxDateOfBirth}
                          className="custom-form-input"
                        />
                      </CCol>
                    </CRow>

                    <CRow className="pt-20">
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="gender"
                          className="custom-form-label"
                        >
                          Email
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormInput
                          type="email"
                          id="email"
                          placeholder="Email"
                          name="email"
                          value={email}
                          onChange={onChangeValue}
                          required
                          className="custom-form-input"
                        />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="phoneNumber"
                          className="custom-form-label"
                        >
                          Phone Number
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormInput
                          type="text"
                          id="phoneNumber"
                          minLength={10}
                          maxLength={10}
                          placeholder="Phone Number"
                          name="phoneNumber"
                          value={phoneNumber}
                          onChange={onChangeValue}
                          required
                          className="custom-form-input"
                        />
                      </CCol>
                    </CRow>

                    <div className="staffform_header">Staff Details :</div>

                    <CRow className="pt-20">
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="dateOfHire"
                          className="custom-form-label"
                        >
                          Joining Date
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormInput
                          type="date"
                          id="dateOfHire"
                          name="dateOfHire"
                          value={dateOfHire}
                          onChange={onChangeValue}
                          max={maxJoining}
                          className="custom-form-input"
                        />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="address"
                          className="custom-form-label"
                        >
                          Address
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormInput
                          type="text"
                          id="address"
                          placeholder="Address"
                          name="address"
                          value={address}
                          onChange={onChangeValue}
                          required
                          className="custom-form-input"
                        />
                      </CCol>
                    </CRow>
                    <CRow className="pt-20">
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="employeeRole"
                          className="custom-form-label"
                        >
                          Staff Role
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormSelect
                          className="mb-4 custom-select custom-form-input"
                          id="employeeRole"
                          name="employeeRole"
                          value={employeeRole}
                          onChange={onChangeValue}
                          type="select"
                          required
                        >
                          <option value="">Select Role</option>
                          <option value="manager">Manager</option>
                          <option value="employee">Staff</option>
                          <option value="agent">Agent</option>
                        </CFormSelect>
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="shopName"
                          className="custom-form-label"
                        >
                          Shop Name
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormInput
                          id="shopName"
                          type="text"
                          placeholder="Enter Your Shop Name"
                          name="shopName"
                          value={shopName}
                          onChange={onChangeValue}
                          required
                          className="custom-form-input"
                        />
                      </CCol>
                    </CRow>

                    <CRow className="pt-20"></CRow>

                    <div className="staffform_header">
                      Verification Details :
                    </div>

                    <CRow className="pt-20">
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="aadharNumber"
                          className="custom-form-label"
                        >
                          Aadhar Number
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormInput
                          id="aadharNumber"
                          type="number"
                          placeholder="Aadhar Card Number"
                          name="aadharNumber"
                          value={aadharNumber}
                          onChange={onChangeValue}
                          required
                          className="custom-form-input"
                        />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="aadharImageUrl"
                          className="custom-form-label"
                        >
                          Upload Aadhar Card
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormInput
                          type="file"
                          ref={aadharImageRef}
                          id="aadharImageUrl"
                          placeholder="Upload Aadhar Card"
                          name="aadharImageUrl"
                          value={aadharImageUrl}
                          onChange={onChangeValue}
                          required
                          className="custom-form-input"
                        />
                      </CCol>
                    </CRow>

                    <CRow className="pt-20">
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="passportSizePhoto"
                          className="custom-form-label"
                        >
                          Passport Size Photo
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormInput
                          type="file"
                          ref={passPortPhotoRef}
                          id="passportSizePhoto"
                          placeholder="Passport Size Photo"
                          name="passportSizePhoto"
                          value={passportSizePhoto}
                          onChange={onChangeValue}
                          required
                          className="custom-form-input"
                        />
                      </CCol>
                    </CRow>
                    <CRow className="pt-20"></CRow>
                    <div className="staffform_header">
                      Emergency Contact Information :
                    </div>
                    <CRow className="pt-20 mb-4">
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="emergencyContactInformation"
                          className="custom-form-label"
                        >
                          Name
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormInput
                          type="text"
                          id="emergencyContactInformation"
                          placeholder="Name"
                          name="emergencyContactInformation"
                          value={emergencyContactInformation}
                          onChange={onChangeValue}
                          required
                          className="custom-form-input"
                        />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="emergencyContactNumber"
                          className="custom-form-label"
                        >
                          Contact Number
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormInput
                          type="text"
                          minLength={10}
                          maxLength={10}
                          id="emergencyContactNumber"
                          placeholder="Contact Number"
                          name="emergencyContactNumber"
                          value={emergencyContactNumber}
                          onChange={onChangeValue}
                          required
                          className="custom-form-input"
                        />
                      </CCol>
                    </CRow>
                    <CRow className="pt-20">
                      <CCol xs={6}>
                        <CFormLabel
                          htmlFor="empStatus"
                          className="custom-form-label"
                        >
                          Status
                          <span className="red-star">{` `}*</span>
                        </CFormLabel>
                        <CFormSelect
                          className="custom-select custom-form-input"
                          id="empStatus"
                          name="empStatus"
                          type="empStatus"
                          value={empStatus}
                          onChange={onChangeValue}
                          required
                        >
                          <option value="">Select Status</option>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </CFormSelect>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol xs={4}></CCol>
                      <CCol xs={7} className="error_er">
                        <span
                          className="red-star"
                          style={{ margin: " 0px 54px" }}
                        >
                          {error}
                        </span>
                      </CCol>
                    </CRow>

                    <CRow style={{ paddingTop: 30 }}>
                      <CCol xs={6} className="text-end">
                        {isEdit ? (
                          <>
                            <CButton
                              type="submit"
                              color="primary"
                              className="px-4"
                            >
                              {isEdit ? "Update" : "Submit"}
                            </CButton>
                          </>
                        ) : (
                          <>
                            {loader ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Loader />
                              </div>
                            ) : (
                              <>
                                {showBtn ? (
                                  <CButton
                                    type="submit"
                                    color="primary"
                                    className="px-4"
                                  >
                                    {isEdit ? "Update" : "Submit"}
                                  </CButton>
                                ) : (
                                  <CButton
                                    color="primary"
                                    onClick={() => setVisible(true)}
                                    className="px-4"
                                  >
                                    set Permissions
                                  </CButton>
                                )}
                              </>
                            )}
                          </>
                        )}
                        {/* <CButton type="submit" color="primary" className="px-4">
                          {isEdit ? "Update" : "Submit"}
                        </CButton> */}
                      </CCol>
                      <CCol xs={6} className="text-left">
                        <CButton
                          onClick={() => navigate("/staff")}
                          color="primary"
                          className="px-4"
                          style={{ backgroundColor: "red" }}
                        >
                          Cancel
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CContainer>
              </CCardBody>
            </div>
          </CCard>
        </CCol>
      </CRow>
    </>
  );
};

export default AddStaffForm;
